import { IconProps } from "./";
import Icon from "./assets/people_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24People(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
